import React from 'react';
import './VCNRDifferentSection.css';
import logo from '../../Assets/vcnr-logo-white.png'; // Your logo image path

const VCNRDifferentSection = () => {
  return (
    <section className="vcnr-diff-section">
      {/* Gradient + Rock Background handled in CSS ::before and ::after */}
      <div className="vcnr-diff-overlay">
        <div className="vcnr-diff-content">
          <h2 className="vcnr-diff-heading">More Than Business. A Movement.</h2>
          <div className="vcnr-diff-logo-line">
            <img src={logo} alt="VCNR Logo" className="vcnr-diff-logo" />
            <span className="vcnr-diff-text">DIFFERENT</span>
          </div>
          <p className="vcnr-diff-subtitle">
            VCNR is not just a business group, it is a social movement in motion.
          </p>

          <div className="vcnr-diff-description-line"></div>

          <p className="vcnr-diff-description">
            What sets us apart is a deep, enduring commitment to inclusivity. From bringing technology access to rural youth, to conducting thousands of free medical camps, to launching India’s first women-led agri innovation zones, we don’t just build businesses, we build bridges.
          </p>
          <p className="vcnr-diff-description">Because at VCNR, people’s success is our success.</p>

          <h3 className="vcnr-diff-quote">
            " While others aim for profit, we aim for purpose, and that’s how profit finds its way back. "
          </h3>
        </div>
      </div>

    </section>
  );
};

export default VCNRDifferentSection;
